import { Component, ViewEncapsulation, Input, ElementRef, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { RequestsServices } from './../../services/requests.service';
import { UserService } from './../../services/user.service';
import { StorageService } from './../../services/storage.service';
import { ToasterService } from '../../services/toaster.service';
import { marker, icon, latLng, Layer, tileLayer, map } from 'leaflet';

import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/merge';

import { SearchService } from './../../services/search.service';
import { CompanyService } from 'src/app/services/company.service';
import { select, Store } from '@ngrx/store';
import { getUser } from 'src/app/store/selectors/auth.selectors';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'component-filters',
  templateUrl: './nav-filters.html',
  encapsulation: ViewEncapsulation.None,
  providers: [RequestsServices, StorageService, UserService, CompanyService]
})

export class FiltersComponent implements OnInit {

  // Search altocomplete
  private nearOf: boolean = true;
  private modelDetail: string = "";
  private locationsTitle: string = 'Seus endereços';
  private nearSearch: string = 'Minha localização';
  private nearSearchArray = [];
  private forLocalization: boolean = false;
  private searching: boolean = false;
  private searchFailed: boolean = false;
  private searchFailedHidden: boolean = false;
  private hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  public disableSearch: boolean = false;
  private inputboxSubscription: Subscription;

  // infinit scroll
  private el: any;
  public endSlice = 4;
  private firstScroll: boolean = true;
  private countElements: number = 0;

  private skipItems: number = 0;
  private limitItems: number = 20;

  private skipItemsOwn: number = 0;
  private limitItemsOwn: number = 3;

  private skipItemsOnline: number = 0;

  private userGeolocation = {lat: null, lng: null};
  private lastLocationSelected = {name: null, lat: null, lng: null};

  public toggleOpenNav: boolean = false;
  public toggleOpenMap: boolean = false;

  public filterByLocationInput: boolean = false;
  public noResults: boolean = false;
  public noItems: boolean = false;

  public pageLoading: boolean = true;
  public resultsLoading: boolean = false;
  public categories: Object;
  public establishmentUnits: Array<Object>;
  public partnership: Object;
  public establishmentsListArray: any = [];
  public hasEstablishmentsResult: boolean = false;
  public partnershipsOwnResult: boolean = false;
  public onlineListResult: boolean = false;
  public companiesListArray: any = [];
  public onlineList: any = [];

  public dropCategory: boolean = false;
  public dropLocation: boolean = false;
  public dropLocationEstablishment: boolean = false;
  public dropAdvancedSearchCompany: boolean = false;
  public dropPartnership: boolean = false;
  public categoriesSelected = [];
  public categoriesSelectedName = [];
  public myLocalSelected: boolean = true;
  public establishmentUnitsSelected = [];

  public partnershipTypeSelected = [];
  public partnershipSelectedName = [];
  public typePartnerSelected = [];
  public partnershipCheck: any;
  private viewMore: boolean = false;
  // set object to send
  public objectFilters: any = {
    generic: '',
    modalities: true,
    categoryId: ''
  };

  public objectToSend: object = {
    generic: '',
    filters: [
      {
        modalities: { inq: [1] }
      }
    ]
  };

  // Map options
  @Input('leafletMarkers')
  markers: Layer[] = [];

  private defaultLocation: object = {
    lat: -13.7013576,
    lng: -51.0536984
  };
  public fitBounds = [[this.defaultLocation['lat'], this.defaultLocation['lng']]];
  private LAYER_OSM = tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18, attribution: 'Open Street Map' });
  public mapCenterOptions = latLng(this.defaultLocation['lat'], this.defaultLocation['lng']);
  public mapZoom: number = 5;

  public options = {
    layers: [ this.LAYER_OSM ],
    zoom: this.mapZoom,
    center: this.mapCenterOptions
  };

  user;

  constructor(
    public element: ElementRef,
    private request: RequestsServices,
    private storage: StorageService,
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    private toaster: ToasterService,
    private searchService: SearchService,
    private router: Router,
    private companyService: CompanyService,
    private store: Store
  ) {
    this.el = element.nativeElement;
    this.store.pipe(select(getUser)).subscribe(user => this.user = user);
  }

  editOwnPartnership(partnershipId: string) {
    if (!partnershipId) {
      return;
    }

    const id = encodeURIComponent(partnershipId);
    window.location.href = `${environment.PORTAL_URL}/dashboard/parcerias-exclusivas/cadastrar?id=${id}`;
  }

  // Search for localization
  // =======================

  public searchLocation = (text$: Observable<string>) =>
    text$
      .debounceTime(300)
      .distinctUntilChanged()
      .do(() => {
        this.searching = true;
        this.forLocalization = true;
      })
      .switchMap(msg =>
        this.searchService.sendSearchKey(msg)
          .do((res) => {
            if (res[0].length > 0) {
              this.searchFailed = true;
              this.searchFailedHidden = false;
            } else {
              this.searchFailed = false;
              this.searchFailedHidden = true;
            }
          })
          .catch((err) => {
            this.searchFailed = true;
            this.searchFailedHidden = false;
            this.disableSearch = true;
            navigator.geolocation.getCurrentPosition((pos) => {
              const lat = pos.coords.latitude;
              const lng = pos.coords.longitude;
              this.userGeolocation.lat = lat;
              this.userGeolocation.lng = lng;
              this.nearSearch = 'Minha localização';
              this.disableSearch = false;
            }, () => {
              // User denied geolocation or it was unavailable
              this.toaster.info('Localização',
                'Para identificar estabelecimentos próximos, precisamos que nos permita sua localização!', false, 5000);
              this.disableSearch = false;
            });
            setTimeout(() => {
              this.searchFailedHidden = true;
              this.forLocalization = false;
              this.locationsTitle = 'Seus endereços';
            }, 2500);
            return of([]);
          }))
      .do(() => {
        this.searching = false;
        this.locationsTitle = 'Resultados da busca';
      })
      .merge(this.hideSearchingWhenUnsubscribed);

  private formatter = (x: {text: string}) => x.text;

  private getDetail(modelDetail) {
    const item = modelDetail.item.magicKey;
    this.nearOf = true;
    this.myLocalSelected = false;
    this.forLocalization = true;
    this.locationsTitle = 'Local selecionado';
    this.nearSearch = modelDetail.item.text.split(',')[0];
    this.nearSearchArray = [this.nearSearch];

    // set Location
    this.searchService.sendmagicKey(item);
    this.searchService.getDetail().subscribe((data) => {
      this.filterByLocationInput = true;
      this.userGeolocation.lat = data.location.y;
      this.userGeolocation.lng = data.location.x;
    });
  }

  private removeLocation() {
    this.nearSearch = 'Minha localização';
    this.locationsTitle = 'Seus endereços';
    this.nearSearchArray = [];
    this.modelDetail = '';
    this.forLocalization = false;
    this.requestBrowserGeolocation();
    this.selectAllEstablishmentUnits();
  }

  // =======================
  // Search for localization

  private getUserLevel(): string {
    const userLevel = this.userService.getUserLevel();
    return userLevel;
  }

  private scrolled(event) {
    this.resultsLoading = true;

    if (!this.viewMore) {

      if (this.getTypeBusiness() === 'company') {
        if (this.establishmentsListArray.length > this.countElements) {
          this.skipItems += 20;
          this.skipItemsOwn += 3;
          this.skipItemsOnline = 4;
          if (this.firstScroll) {
            this.firstScroll = false;
          }
          this.filter(this.objectFilters);
        } else {
          this.resultsLoading = false;
          this.noItems = true;
        }
        this.countElements = this.establishmentsListArray.length;
      } else {
        if (this.companiesListArray.length > this.countElements) {
          this.skipItems += 20;
          this.skipItemsOwn += 3;
          if (this.firstScroll) {
            this.firstScroll = false;
          }
          this.filter(this.objectFilters);
        } else {
          this.resultsLoading = false;
          this.noItems = true;
        }
        this.countElements = this.companiesListArray.length;
      }

    } else {

      if (this.onlineList.length > this.countElements) {
        this.skipItems += 20;
        this.skipItemsOwn += 3;
        this.skipItemsOnline += 6;
        if (this.firstScroll) {
          this.firstScroll = false;
        }
        this.filter(this.objectFilters);
      } else {
        this.resultsLoading = false;
        this.noItems = true;
      }

      this.countElements = this.onlineList.length;
    }

  }

  public openContent(val: string): void {
    switch (val) {
      case 'nav-filters':
        this.toggleOpenNav ? this.toggleOpenNav = false : this.toggleOpenNav = true;
        this.toggleOpenMap = false;
        break;

      case 'content-map':
        this.toggleOpenMap ? this.toggleOpenMap = false : this.toggleOpenMap = true;
        this.toggleOpenNav = false;
        break;
    }
  }

  public openDropFilter(val: string): void {
    switch (val) {
      case 'category':
        this.dropCategory ? this.dropCategory = false : this.dropCategory = true;
        this.dropLocation = false;
        this.dropPartnership = false;
        break;

      case 'location':
        this.dropCategory = false;
        this.dropLocation ? this.dropLocation = false : this.dropLocation = true;
        this.dropPartnership = false;
        break;

      case 'partnership':
        this.dropCategory = false;
        this.dropLocation = false;
        this.dropPartnership ? this.dropPartnership = false : this.dropPartnership = true;
        break;

      case 'overlay':
        this.dropCategory = false;
        this.dropLocation = false;
        this.dropPartnership = false;
        this.dropLocationEstablishment = false;
        this.dropAdvancedSearchCompany = false;
        break;

      case 'locationEstablishment':
        this.dropLocationEstablishment ? this.dropLocationEstablishment = false : this.dropLocationEstablishment = true;
        break;

      case 'advancedSearchCompany':
        this.dropAdvancedSearchCompany ? this.dropAdvancedSearchCompany = false : this.dropAdvancedSearchCompany = true;
        break;
    }
  }

  public viewMoreToggle(): void {
    this.skipItems = 0;
    this.countElements = 0;
    this.pageLoading = true;
    this.markers = [];
    this.onlineList = [];
    if (this.viewMore) {
      this.viewMore = false;
      this.skipItemsOnline = 6;
      this.filter(this.objectFilters);
    } else {
      this.establishmentsListArray = [];
      this.skipItemsOnline = 0;
      this.skipItemsOwn = 0;
      this.viewMore = true;
    }
    this.fetchOnline(this.objectFilters);
  }

  public fetchOnline(objectFilters?): void {
    if (this.viewMore) {
      this.fetchPartnershipsOwn();
    }

    const genericItemOnline: any = {
      skip: this.skipItems,
      limit: this.limitItems,
      filters: [
        { modalities: {inq: [1] }},
        {
          or: [
            { 'name': { 'like': objectFilters['generic'], options: 'gi' } },
            { 'offer.title': { 'like': objectFilters['generic'], options: 'gi' } },
            { 'offer.term': { 'like': objectFilters['generic'], options: 'gi' } }
          ]
        }
      ],
    };
    let categoriesIds = [];

    if (this.categories) {
      categoriesIds = this.getCategoriesIdsSelected(this.categories);
    }

    if (objectFilters['categoryId'].length > 5) {
      categoriesIds.push(objectFilters.categoryId);
    }

    if (!objectFilters.modalities && categoriesIds.length === 0) {
      this.requestEstabOnline(this.user, genericItemOnline);
    } else if (objectFilters.modalities && categoriesIds.length === 0) {
      this.requestEstabOnline(this.user, genericItemOnline);
    } else if (objectFilters.modalities && categoriesIds.length > 0) {
      genericItemOnline.filters.push({ categoryId: { inq: categoriesIds }});
      this.requestEstabOnline(this.user, genericItemOnline);
    } else {
      genericItemOnline.filters.push({ categoryId: { inq: categoriesIds }});
      this.requestEstabOnline(this.user, genericItemOnline);
    }
  }

  private requestEstabOnline(usr, genericItemOnline: any) {
    this.request.post('customers', genericItemOnline, 'filters').then(
      (result) => {
        result.list.map((item) => {
          this.onlineList.push(item);
        });
        this.onlineList.length > 0 ? this.onlineListResult = true : this.onlineListResult = false;
        this.pageLoading = false;
      }
    );
  }

  public onSelectCategory($event, i): void {
    this.categories[i]['isSelected'] = this.categoriesSelected[i];
    this.objectFilters['categoryId'] = this.categories[i]['isSelected'];
    this.categoriesSelectedName = this.getCategoriesNameSelected(this.categories);
  }

  public onSelectEstablishmentUnit($event, index?): void {
    if (typeof index === 'number') {
      this.establishmentUnits.map(item => {
        item['isSelected'] = false;
        this.establishmentUnits[index]['isSelected'] = true;
      });
      if (this.establishmentUnits[index]['isSelected']) {
        this.myLocalSelected = false;
        this.nearSearch = this.establishmentUnits[index]['name'];

        this.userGeolocation.lat = this.establishmentUnits[index]['location'][0];
        this.userGeolocation.lng = this.establishmentUnits[index]['location'][1];

        this.lastLocationSelected.name = this.establishmentUnits[index]['name'];
        this.lastLocationSelected.lat  = this.establishmentUnits[index]['location'][0];
        this.lastLocationSelected.lng  = this.establishmentUnits[index]['location'][1];

      }
    } else {
      if (this.nearOf) {
        if ($event === 'myLocal') {
          this.myLocalSelected = true;
          this.nearSearch = 'Minha localização';
        }
      } else {
        this.nearSearch = 'BR';
        this.userGeolocation.lat = this.defaultLocation['lat'];
        this.userGeolocation.lng = this.defaultLocation['lng'];
      }
    }
  }

  public selectAllEstablishmentUnits(): void {
    this.establishmentUnits.forEach((establishment, i) => {
      this.establishmentUnitsSelected[i] = false;
      // this.onSelectEstablishmentUnit(null, i);
    });
  }

  public onSelectPartnership($event, i) {
    this.partnershipCheck[i]['isSelected'] = this.typePartnerSelected[i];
    this.partnershipTypeSelected = this.getPartnershipTypeSelected(this.partnershipCheck);
    this.partnershipSelectedName = this.getPartnershipNameSelected(this.partnershipCheck);
  }

  public olineList(val?) {
    for (let filterLoop = 0; filterLoop < this.objectToSend['filters'].length; ++filterLoop) {
      let filterItem = this.objectToSend['filters'][filterLoop];
      if (val && this.objectToSend['filters'][filterLoop]['modalities']) {
        this.objectToSend['filters'][filterLoop]['modalities']['inq'] = [1];
        break;
      } else if (val && this.objectToSend['filters']) {
        this.objectToSend['filters'].push({'modalities': {'inq': [1]}});
      }
    }
  }

  public getPartnershipTypeSelected(partnershipType: any): Array<string> {
    return partnershipType.filter((partnership) => {
      return partnership['isSelected'];
    }).map((partnership) => {
      return partnership['id'];
    });
  }

  public getPartnershipNameSelected(partnershipType: any): Array<string> {
    return partnershipType.filter((partnership) => {
      return partnership['isSelected'];
    }).map((partnership) => {
      return partnership['name'];
    });
  }

  public getCategoriesIdsSelected(categories: any): Array<string> {
    return categories.filter((category) => {
      return category['isSelected'];
    }).map((category) => {
      return category['id'];
    });
  }

  public getCategoriesNameSelected(categories: any): Array<string> {
    return categories.filter((category) => {
      return category['isSelected'];
    }).map((category) => {
      return category['name'];
    });
  }

  public getEstablishmentUnitsNameSelected(establishmentUnits: any): Array<string> {
    return establishmentUnits.filter((establishment) => {
      return establishment['isSelected'];
    }).map((establishment) => {
      return establishment['name'];
    });
  }

  private fetchPartnershipsOwn(): void {
    let categoriesIds = [];
    const companyLogged = this.getLoggedCompany();
    const companyId = companyLogged.id;
    const genericItem: any = {
      skip: this.skipItemsOwn,
      limit: this.limitItemsOwn,
      filters : []
    };

    if (this.categories) {
      categoriesIds = this.getCategoriesIdsSelected(this.categories);
    }

    if (categoriesIds.length) {
      genericItem.filters.push({ categoryId: { inq: categoriesIds }});
    }

    if (this.objectFilters['modalities']) {
      genericItem.filters.push({ modalities: { inq: [1, 2, 3] }});
    } else {
      genericItem.filters.push({ modalities: { inq: [2, 3] }});
    }

    if (this.objectFilters && this.objectFilters.generic) {
      genericItem.filters.push({
        or: [
          {'name': {like: this.objectFilters.generic, options: 'gi'}},
          {'offer.title': {like: this.objectFilters.generic, options: 'gi'}},
          {'offer.term': {like: this.objectFilters.generic, options: 'gi'}}
        ]
      });
    }

    // TODO: INSERIR PARCERIAS PROPRIAS

    this.request.post('customers', genericItem, '',
      `/company/${companyId}/partnerships/filters?near=${this.userGeolocation.lat},${this.userGeolocation.lng}`)
      .then((result) => {
        if (result.list.length > 0) {
          result.list.map((item) => {
            item.partnershipOwn = true;
            this.partnershipsOwnResult = true;
            if (item.urls.url_website) {
              this.onlineList.push(item);
            } else {
              this.establishmentsListArray.push(item);
            }
          });
        }
      }
    );
  }

  public searchFor(objectFilters, event) {
    this.firstScroll = true;
    this.pageLoading = true;
    this.noItems = false;

    this.limitItems = 20;

    this.countElements = 0;
    this.skipItems = 0;
    this.skipItemsOwn = 0;
    this.skipItemsOnline = 0;

    this.establishmentsListArray = [];
    this.companiesListArray = [];
    this.onlineList = [];

    this.openDropFilter('overlay');

    if (this.nearOf && this.myLocalSelected) {
      this.nearSearch = 'Minha localização';
      this.requestBrowserGeolocation();
    }

    if (!this.nearOf) {
      this.nearSearch = 'BR';
      this.userGeolocation.lat = this.defaultLocation['lat'];
      this.userGeolocation.lng = this.defaultLocation['lng'];
    }

    this.mapCenterOptions = latLng(this.userGeolocation.lat, this.userGeolocation.lng);

    if (objectFilters.generic && objectFilters.generic.length > 0) {
      this.router.navigate(['/listagem'], { queryParams: { search: objectFilters.generic } });
    } else {
     this.router.navigate(['/listagem'], { queryParams: { category: objectFilters.categoryId } });
    }

    if ((this.nearOf && !this.myLocalSelected) || !this.nearOf) {
      if (this.nearOf && this.myLocalSelected && !this.filterByLocationInput) {
        this.nearSearch = this.lastLocationSelected.name;
        this.userGeolocation.lat = this.lastLocationSelected.lat;
        this.userGeolocation.lng = this.lastLocationSelected.lng;
      }
      this.filterByLocationInput = false;
      this.filter(objectFilters);
    }
  }

  public filter(objectFilters): void {
    if (!this.resultsLoading || this.viewMore) {
      this.fetchOnline(objectFilters);
    }
    if (this.getTypeBusiness() === 'company' && !this.viewMore) {
      this.applyFilterForEstablishments(objectFilters);
    } else if (this.getTypeBusiness() === 'establishment') {
      this.applyFilterForCompanies();
    }
  }

  private applyFilterForCompanies(): void {
    this.fetchEstablishmentPartnershipsOwn();

    const location = {
      lat: this.userGeolocation.lat,
      lng: this.userGeolocation.lng
    };

    const params = [
      { param: 'location', value: JSON.stringify(location) },
      { param: 'skip', value: this.skipItems },
      { param: 'limit', value: this.limitItems },
      { param: 'query', value: this.objectFilters.generic || '' },
    ];

    this.companyService.listCompaniesByLocation(params).then(
      (result) => {
        this.setCompanyList(result.data);
        this.resultsLoading = false;
      }
    );
  }

  private fetchEstablishmentPartnershipsOwn(firstFetch: boolean = false): void {
    const establishmentLogged = this.getLoggedEstablishment();
    const establishmentId = establishmentLogged.id;

    const genericItem: any = {
      filters : [],
      skip: this.skipItemsOwn,
      limit: this.limitItemsOwn
    };

    if (this.objectFilters && this.objectFilters['generic']) {
      genericItem.filters.push({
        company_name: { like: this.objectFilters['generic'], options: 'gi' }
      });
    }

    this.request.post('customers', genericItem, '', `/establishment/${establishmentId}/partnerships/filters`).then(
      (result) => {
        result.list.map((item) => {
          item.partnershipOwn = true;
          this.companiesListArray.push(item);
        });
      }
    );
  }

  private getEndpointListEstablishments(): string {
    return `/establishment/listing/filters?near=${this.userGeolocation.lat},${this.userGeolocation.lng}`;
  }

  private getEndpointListCompanies(): string {
    return `/company/listing/filters?near=${this.userGeolocation.lat},${this.userGeolocation.lng}`;
  }

  private applyFilterForEstablishments(objectFilters): void {
    this.fetchPartnershipsOwn();

    let categoriesIds = [];
    if (this.categories) {
      categoriesIds = this.getCategoriesIdsSelected(this.categories);
    }
    if (objectFilters['categoryId'].length > 5) {
      categoriesIds.push(objectFilters.categoryId);
    }

    const genericItem: any = {
      skip: this.skipItems,
      limit: this.limitItems,
      filters: [
        { modalities: {inq: [2, 3] }},
        {
          or: [
            { 'name': { 'like': objectFilters['generic'], options: 'gi' } },
            { 'offer.title': { 'like': objectFilters['generic'], options: 'gi' } },
            { 'offer.term': { 'like': objectFilters['generic'], options: 'gi' } }
          ]
        }
      ]
    };

    if (!objectFilters.modalities && categoriesIds.length === 0) {
      this.requestEstabs(this.user, genericItem);
    } else if (objectFilters.modalities && categoriesIds.length === 0) {
      this.requestEstabs(this.user, genericItem);
    } else if (objectFilters.modalities && categoriesIds.length > 0) {
      genericItem.filters.push({ categoryId: { inq: categoriesIds }});
      this.requestEstabs(this.user, genericItem);

    } else {
      genericItem.filters.push({ categoryId: { inq: categoriesIds }});
      this.requestEstabs(this.user, genericItem);
    }
  }

  private requestEstabs(usr, genericItem: any) {
    this.request.post('customers', genericItem, '', this.getEndpointListEstablishments()).then(
      (result) => {
        this.resultsLoading = false;
        this.setEstablishmentList(result.list);
      }
    );
  }

  private getLoggedCompany(): any {
    return this.userService.getLoggedAccount();
  }

  private getLoggedEstablishment(): any {
    return this.userService.getLoggedAccount();
  }

  public getTypeBusiness(): string {
    return this.userService.getTypeAccount();
  }

  ngOnInit() {
    this.inputboxSubscription = this.searchService.getClear().subscribe(() => {
      this.modelDetail = '';
    });

    // Get Categories
    this.request.get({path: 'categories'}).then(
      (result) => {
        this.categories = result;
      }
    );

    this.partnershipCheck = [
      {
        name: 'Próprias',
        id: 'proprias_id'
      },
      {
        name: 'Colaboradores',
        id: 'colab_id'
      }
    ];

    // Request Geolocation
    this.requestBrowserGeolocation();
  }

  private requestBrowserGeolocation(): void {
    navigator.geolocation.getCurrentPosition((pos) => {
      const lat = pos.coords.latitude;
      const lng = pos.coords.longitude;

      this.userGeolocation.lat = lat;
      this.userGeolocation.lng = lng;

      this.skipItems = 0;
      this.establishmentsListArray = [];
      this.mapCenterOptions = latLng(this.userGeolocation.lat, this.userGeolocation.lng);
      this.mapZoom = 12;
      this.initListing();

    }, () => {
      // User denied geolocation or it was unavailable
      this.toaster.info('Localização',
      'Para identificar estabelecimentos próximos, precisamos que nos permita sua localização!', false, 5000);
      this.initListing();
    });
  }

  private initListing(): void {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if ('search' in params && params.search) {
        this.objectFilters['generic'] = params.search;
        this.filter(this.objectFilters);
      } else if ('category' in params && params.category) {
        this.objectFilters['categoryId'] = params.category;
        this.filter(this.objectFilters);
      } else {
        if (this.userGeolocation.lng && this.userGeolocation.lat) {
          this.initTypeListing();
        } else {
          this.filter(this.objectFilters);
        }
      }

      // Get addresses
      const addresses = this.userService.getAccountAddresses();

      if (addresses) {
        this.establishmentUnits = [];
        addresses.map((address, i) => {
          this.establishmentUnits.push({
            isSelected: false,
            id: i,
            name: address.nameUnit,
            location: [ address.location.lat, address.location.lng ]
          });
        });
        this.selectAllEstablishmentUnits();
      } else {
        // Establishment is online and have no addresses
        this.establishmentUnits = [];
      }

    }).unsubscribe();
  }

  private initTypeListing(): void {
    if (this.getTypeBusiness() === 'company') {
      this.initListingAsCompany();
    } else if (this.getTypeBusiness() === 'establishment') {
      this.initListingAsEstablishment();
    }
  }

  private initListingAsCompany(): void {
    this.fetchAllEstablishments();
  }

  private initListingAsEstablishment(): void {
    this.fetchAllCompanies();
  }

  private fetchAllEstablishments(): void {
    this.filter(this.objectFilters);
  }

  private fetchAllCompanies(): void {
    this.filter(this.objectFilters);
  }

  private hiddenCard(card: any, type: string): void {
    let hide: boolean = true;
    const companyLogged = this.getLoggedCompany();

    //TODO: get company logged
    const selectIdTypeUser = this.user.typeBusiness === 'company'
      ? companyLogged.id
      : this.user.establishments[0].id

    if (type === 'online') {
      this.onlineList.forEach(objOnline => {
        if (objOnline.id == card.id && objOnline['hide']) {
          hide = false;
        }
      });
    } else {
      this.establishmentsListArray.forEach(comp => {
        if (comp.id == card.id && comp['hide']) {
          hide = false;
        }
      });
    }

    this.request.post('customers', '', '', `/${this.user.customerId}/company/${selectIdTypeUser}/hide/${hide}/${card.id}`).then(
      (result) => {
        if (result['hidden']) {
          let createListOnline: Array<Object>;
          let createListComp: Array<Object>;
          createListOnline = this.onlineList.map((objOnline) => {
            if (objOnline.id == card.id && result.hidden.hide) {
              objOnline['hide'] = true;
            } else if (objOnline.id == card.id && result.hidden.show) {
              objOnline['hide'] = false;
            }
            return objOnline;
          });

          createListComp = this.establishmentsListArray.map((comp) => {
            if (comp.id == card.id && result.hidden.hide) {
              comp['hide'] = true;
            } else if (comp.id == card.id && result.hidden.show) {
              comp['hide'] = false;
            }
            return comp;
          });

          this.onlineList = createListOnline;
          this.setEstablishmentList(createListComp);
        }
      }
    );
  }

  public getSearchLabel(): string {
    if (this.getTypeBusiness() === 'establishment') {
      return 'Pesquisar';
    } else {
      return 'Busca';
    }
  }

  public getPlaceholderForSearch(): string {
    if (this.getTypeBusiness() === 'establishment') {
      return 'nome da empresa';
    } else {
      return 'nome, serviço';
    }
  }

  private clearMapMarkers(): void {
    this.markers = [];
  }

  private setEstablishmentList(establishments): void {
    this.pageLoading = false;
    let establishmentLocation = [];
    establishmentLocation.push([this.userGeolocation.lat, this.userGeolocation.lng]);
    if (establishments.length > 0) {
      establishments.map((item) => {
        this.establishmentsListArray.push(item);
      });
      if (this.establishmentsListArray.length > 0) {
        this.establishmentsListArray.map((item) => {
          if (item && item.nearestAddress) {
            if (item.nearestAddress.location['lat'] && item.nearestAddress.location['lng']) {
              establishmentLocation.push([item.nearestAddress.location['lat'], item.nearestAddress.location['lng']]);
            }
          }
        });
      }
      this.fitBounds = establishmentLocation;
      this.setMarkersForEstablishments(this.establishmentsListArray);
    }

    if (this.establishmentsListArray.length > 0) {
      this.hasEstablishmentsResult = true;
    } else {
      this.hasEstablishmentsResult = false;
    }

    if (this.viewMore) {
      if (this.onlineListResult) {
        this.resultsLoading = false;
        this.noResults = false;
      } else {
        this.resultsLoading = false;
        this.noResults = true;
      }
    } else {
      if (this.hasEstablishmentsResult || this.onlineListResult) {
        this.resultsLoading = false;
        this.noResults = false;
      } else {
        this.resultsLoading = false;
        this.noResults = true;
      }
    }
  }

  private setCompanyList(companies): void {
    let companyLocation = [];
    companyLocation.push([this.userGeolocation.lat, this.userGeolocation.lng ]);

    if (companies.length > 0) {
      companies.map((item) => {
        this.companiesListArray.push(item);
      });

      if (this.companiesListArray.length > 0) {
        this.pageLoading = false;
        this.companiesListArray.map((item) => {
          if (item && item.nearestAddress) {
            if (item.nearestAddress.location['lat'] && item.nearestAddress.location['lng']) {
              companyLocation.push([item.nearestAddress.location['lat'], item.nearestAddress.location['lng']]);
            }
          }
        });

        this.noResults = false;
        this.pageLoading = false;
      } else {
        this.noResults = true;
        this.pageLoading = false;
      }
      this.fitBounds = companyLocation;
      this.setMarkersForCompanies(this.companiesListArray);
    } else if (this.companiesListArray.length === 0) {
      this.noResults = true;
      this.pageLoading = false;
    } else {
      this.pageLoading = false;
    }
  }

  private setMarkersForEstablishments(establishments): void {
    this.clearMapMarkers();
    this.setMyGeolocationMarker();
    establishments.forEach((establishment) => {
      this.setMarkerEstablishment(establishment);
    });
  }

  public setMarkerEstablishment(establishment): void {
    if (establishment.nearestAddress
      && establishment.nearestAddress.location
      && establishment.nearestAddress.location.lat
      && establishment.nearestAddress.location.lng) {
        const image = (establishment && establishment['image'] && establishment['image']['logo']) ? establishment['image']['logo'] : '';
        const name = (establishment && establishment['name']) ? establishment['name'] : '';
        const address = this.getAddressAsString(establishment.nearestAddress);
        const mapCard = `
          <div>
            <div class="card-wrapper">
              <div class="image-card" style="background-image: url('${image}')"></div>
              <div class="card-content">
                <div class="card-content-wrapper">
                  <h2>${name}</h2>
                  <p>${address}</p>
                  <ul>
                    <li><p>$$</p></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        `;

        const newMarker = marker(
          [
            establishment.nearestAddress.location.lat,
            establishment.nearestAddress.location.lng
          ],
          {
            icon: icon({
              iconSize: [ 50, 50 ],
              iconAnchor: [ 13, 41 ],
              iconUrl: `assets/pins/${establishment.category ? establishment.category.slug : 'beleza-e-bem-estar'}.svg`,
              shadowUrl: ''
            })
          }
        ).bindPopup(mapCard).openPopup();
        this.markers.push(newMarker);
    }
  }

  private setMyGeolocationMarker(): void {
    if (this.userGeolocation && this.userGeolocation.lat && this.userGeolocation.lng) {
      const me = marker(
        [ this.userGeolocation.lat, this.userGeolocation.lng ],
        {
          icon: icon({
            iconSize: [ 50, 50 ],
            iconAnchor: [ 13, 41 ],
            iconUrl: 'assets/pins/profissional.svg',
            shadowUrl: ''
          })
        }
      );
      this.markers.push(me);
    }
  }

  private setMarkersForCompanies(companies): void {
    this.clearMapMarkers();
    this.setMyGeolocationMarker();
    companies.forEach((company) => {
      this.setMarkerCompany(company);
    });
  }

  public setMarkerCompany(company): void {
    if (company.nearestAddress
      && company.nearestAddress.location
      && company.nearestAddress.location.lat
      && company.nearestAddress.location.lng) {
        const image = (company && company['image']) ? company['image'] : '';
        const name = (company && company['name']) ? company['name'] : '';
        const address = this.getAddressAsString(company.nearestAddress);
        const mapCard = `
          <div>
            <div class="card-wrapper">
              <div class="image-card" style="background-image: url('${image}')"></div>
              <div class="card-content">
                <div class="card-content-wrapper">
                  <h2>${name}</h2>
                  <p>${address}</p>
                </div>
              </div>
            </div>
          </div>
        `;

        const newMarker = marker(
          [
            company.nearestAddress.location.lat,
            company.nearestAddress.location.lng,
          ],
          {
            icon: icon({
              iconSize: [ 50, 50 ],
              iconAnchor: [ 13, 41 ],
              iconUrl: 'assets/icon/marker-allya.svg',
              shadowUrl: ''
            })
          }
        ).bindPopup(mapCard).openPopup();

        this.markers.push(newMarker);
    }
  }

  public getAddressAsString(addressObject: Object): string {
    const street = addressObject['street'];
    const numberAddress = addressObject['number'];
    const neighborhood = addressObject['neighborhood'];
    const country = addressObject['county'] || addressObject['city'];
    const state = addressObject['state'];
    const cep = addressObject['cep'] || addressObject['zipCode'];
    return street + ', ' + numberAddress + ', ' + neighborhood + ' - ' + country + '/' + state + ' - ' + cep;
  }

}

